<template>
  <v-row dense cols="12">
    <v-col cols="3" class="mt-2">Current margin</v-col>
    <v-col cols="2" class="mt-1 pr-3">    
      <input_amount label="" prefix="%" :amount="wizardData.margin_old" field="margin_old" @updateData="updateData"/>      
    </v-col>
    <v-col cols="3" span="3" class="mt-2 text-center">new margin</v-col>
    <v-col cols="2" class="mt-1 pr-3">
      <input_amount label="" prefix="%" :amount="wizardData.margin_new" field="margin_new" @updateData="updateData"/>
    </v-col>
  </v-row>
</template>

<script>

  import input_amount from '@/components/huis/hspt/ui/input_amount.vue';

  export default {
    props: {
      wizardData: Object
    },
    components: {
      input_amount,
    },
    methods:{
      updateData(data){
        this.$emit('updateData', data);
      },
    },    
  }
</script>

<style scoped>

</style>